import { GraphAuthenticationProvider } from './GraphAuthenticationProvider';

export { GraphClient } from './graph-client';
export const authProvider = new GraphAuthenticationProvider();